import initialState from "../initialState";
import {
	UPCOMING_CHARGES_LOADING,
	CLEAR_UPCOMING_CHARGES,
	SET_UPCOMING_CHARGES,
} from "../actionTypes";

export function upcomingCharges(state = initialState.upcomingCharges, action) {
	switch (action.type) {
		case SET_UPCOMING_CHARGES:
			console.log('SET_UPCOMING_CHARGES');
			return {...state, items: action.data};
		case CLEAR_UPCOMING_CHARGES:
			console.log('CLEAR_UPCOMING_CHARGES');
			return {...state, items: []};
		case UPCOMING_CHARGES_LOADING:
			console.log('UPCOMING_CHARGES_LOADING');
			return {...state, loading: action.toggle};
		default:
			return state;
	}
}